var NativeWebcam = (function() {
  'use strict';

  function getRoot() {
    return document.querySelector('[data-native-webcam]');
  }

  function getElements(root) {
    if (!root) return null;

    return {
      root: root,
      cameraSection: root.querySelector('#camera'),
      video: root.querySelector('[data-webcam-video]'),
      canvas: root.querySelector('[data-webcam-canvas]'),
      status: root.querySelector('[data-webcam-status]'),
      startButton: root.querySelector('[data-webcam-start]'),
      captureButton: root.querySelector('[data-webcam-capture]'),
      retakeButton: root.querySelector('[data-webcam-retake]'),
      stopButton: root.querySelector('[data-webcam-stop]'),
      preview: root.querySelector('.js-temp-avatar'),
      fileInput: document.getElementById('file_input_url'),
      cameraInput: document.getElementById('camera_input_url'),
      avatarRadios: root.querySelectorAll('input[name="avatar_to_use"]')
    };
  }

  function clearAvatarSource(elements, source) {
    if (!elements) return;

    if (source === 'file') {
      if (elements.fileInput) elements.fileInput.value = '';
      var upload = document.getElementById('avatar_upload');
      if (upload) upload.value = '';
    }

    if (source === 'camera') {
      if (elements.cameraInput) elements.cameraInput.value = '';
    }
  }

  function setStatus(elements, message, kind) {
    if (!elements || !elements.status) return;
    elements.status.textContent = message || '';
    elements.status.classList.toggle('text-red-600', kind === 'error');
    elements.status.classList.toggle('text-gray-500', kind !== 'error');
  }

  function updateButtons(elements, state) {
    if (!elements) return;
    if (elements.startButton) elements.startButton.disabled = !!state.streaming;
    if (elements.captureButton) elements.captureButton.disabled = !state.streaming;
    if (elements.retakeButton) elements.retakeButton.disabled = !state.captured;
    if (elements.stopButton) elements.stopButton.disabled = !state.streaming;
  }

  function selectAvatarSource(elements, value) {
    if (!elements || !elements.avatarRadios || !elements.avatarRadios.length) return;

    elements.avatarRadios.forEach(function(radio) {
      radio.checked = radio.value === value;
    });
  }

  function showCameraSection(elements) {
    if (!elements || !elements.cameraSection) return;
    elements.cameraSection.classList.remove('hidden');
    elements.cameraSection.classList.add('block');
  }

  function hideCameraSection(elements) {
    if (!elements || !elements.cameraSection) return;
    elements.cameraSection.classList.add('hidden');
    elements.cameraSection.classList.remove('block');
  }

  function stopStream(elements, state) {
    if (state.stream) {
      state.stream.getTracks().forEach(function(track) { track.stop(); });
      state.stream = null;
    }

    if (elements && elements.video) {
      elements.video.pause();
      elements.video.srcObject = null;
      elements.video.classList.add('hidden');
    }

    if (elements && elements.preview) {
      elements.preview.classList.remove('hidden');
    }

    state.streaming = false;
    updateButtons(elements, state);
  }

  async function startStream(elements, state) {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setStatus(elements, 'Your browser does not support camera capture.', 'error');
      return;
    }

    try {
      stopStream(elements, state);
      state.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'user' },
        audio: false
      });

      if (!elements || !elements.video) return;

      elements.video.srcObject = state.stream;
      elements.video.classList.remove('hidden');
      await elements.video.play();
      state.streaming = true;
      state.captured = false;
      setStatus(elements, 'Camera is ready. Capture a snapshot when you are ready.');
      updateButtons(elements, state);
    } catch (error) {
      setStatus(elements, 'Camera access was blocked or unavailable.', 'error');
      stopStream(elements, state);
    }
  }

  function captureFrame(elements, state) {
    if (!elements || !elements.video || !elements.canvas || !state.stream) return;

    selectAvatarSource(elements, 'camera');

    var width = elements.video.videoWidth || 640;
    var height = elements.video.videoHeight || 480;
    elements.canvas.width = width;
    elements.canvas.height = height;

    var context = elements.canvas.getContext('2d');
    context.drawImage(elements.video, 0, 0, width, height);

    var dataUrl = elements.canvas.toDataURL('image/png');
    if (elements.cameraInput) {
      elements.cameraInput.value = dataUrl;
    }

    if (elements.preview) {
      elements.preview.src = dataUrl;
      elements.preview.classList.remove('hidden');
    }

    if (typeof window.set_avatar_preview === 'function') {
      window.set_avatar_preview();
    }

    stopStream(elements, state);
    state.captured = true;
    setStatus(elements, 'Snapshot captured. You can retake it or save the form.');
    updateButtons(elements, state);
  }

  function bind(root) {
    if (!root || root.dataset.nativeWebcamBound === '1') return;
    root.dataset.nativeWebcamBound = '1';

    var elements = getElements(root);
    var state = {
      stream: null,
      streaming: false,
      captured: false
    };

    function syncFromRadio() {
      var active = root.querySelector('input[name="avatar_to_use"]:checked');
      var usingCamera = active && active.value === 'camera';
      var usingFile = active && active.value === 'file';

      if (usingCamera) {
        clearAvatarSource(elements, 'file');
      }

      if (usingFile) {
        clearAvatarSource(elements, 'camera');
      }

      if (typeof window.set_avatar_preview === 'function') {
        window.set_avatar_preview();
      }

      if (usingCamera) {
        showCameraSection(elements);
        if (!state.streaming) {
          startStream(elements, state);
        }
      } else {
        hideCameraSection(elements);
        stopStream(elements, state);
      }
    }

    if (elements.startButton) {
      elements.startButton.addEventListener('click', function(e) {
        e.preventDefault();
        selectAvatarSource(elements, 'camera');
        showCameraSection(elements);
        startStream(elements, state);
      });
    }

    if (elements.captureButton) {
      elements.captureButton.addEventListener('click', function(e) {
        e.preventDefault();
        captureFrame(elements, state);
      });
    }

    if (elements.retakeButton) {
      elements.retakeButton.addEventListener('click', function(e) {
        e.preventDefault();
        selectAvatarSource(elements, 'camera');
        startStream(elements, state);
      });
    }

    if (elements.stopButton) {
      elements.stopButton.addEventListener('click', function(e) {
        e.preventDefault();
        stopStream(elements, state);
      });
    }

    if (elements.avatarRadios && elements.avatarRadios.length) {
      elements.avatarRadios.forEach(function(radio) {
        radio.addEventListener('change', syncFromRadio);
      });
    }

    document.addEventListener('collapse:expanded', function(event) {
      if (!event.detail || event.detail.collapseId !== 'camera') return;
      var radio = root.querySelector('input[name="avatar_to_use"][value="camera"]');
      if (radio) radio.checked = true;
      showCameraSection(elements);
      startStream(elements, state);
    });

    document.addEventListener('collapse:collapsed', function(event) {
      if (!event.detail || event.detail.collapseId !== 'camera') return;
      stopStream(elements, state);
    });

    document.addEventListener('turbo:before-cache', function() {
      stopStream(elements, state);
    });

    syncFromRadio();
    updateButtons(elements, state);
    setStatus(elements, 'Use the camera button to take a snapshot.');
  }

  function init() {
    var root = getRoot();
    if (root) bind(root);
  }

  return { init: init };
})();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', NativeWebcam.init);
} else {
  NativeWebcam.init();
}

document.addEventListener('turbo:load', NativeWebcam.init);
document.addEventListener('turbolinks:load', NativeWebcam.init);

window.NativeWebcam = NativeWebcam;
